import { IAutomationObject } from '../../types'

export interface IHeatPumpCOP extends IAutomationObject {
    outsideTemperature: number;
    actSCOP: number;
}

export const schema = 'AutomationApps.KPIs.HeatPumpCOP';
 